import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // or another scope that suits your needs
})
export class SplashScreenStateService {
  private _showSplashScreen = true;

  private _showSpinner = new BehaviorSubject(false);

  showSplashScreen() {
    this._showSplashScreen = true;
  }

  hideSplashScreen() {
    this._showSplashScreen = false;
  }

  getShowSplashScreen() {
    return this._showSplashScreen;
  }

  showSpinner() {
    this._showSpinner.next(true);
  }

  hideSpinner() {
    this._showSpinner.next(false);
  }

  get getSpinner() {
    return this._showSpinner.asObservable();
  }
}
